import { AfterViewChecked, AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { Customer } from '../../shared/models/customer.interface';
import { NgForm } from '@angular/forms';
import { JobService } from '../services/job.service';
import { MessageNnotificationTypes_Enum } from '../../admin/enums/message-notification-types.enum';


export interface NotificationData {
  customerId: number;
  projectName: string;
  arrivalInterval: number;
  notificationComment: string;
  notificationType: number;
}

export interface WorkOrderData {
  projectName: string;
  customer: Customer;
}

@Component({
  selector: 'app-arrival-notification-dialog',  
  templateUrl: './arrival-notification-dialog.html',
  styleUrl: './arrival-notification-dialog.scss'
})


export class ArrivalNotificationDialog extends AbstractBiditComponent implements OnInit, AfterViewInit{

  notifyAllowed: boolean = false;
  arrivalData: NotificationData = {customerId: null, projectName: null, arrivalInterval: null, notificationComment: null, notificationType: 3};
  hasSMSContact: boolean = false;
  hasEmailContact: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ArrivalNotificationDialog>,
    private deviceDetectorService: DeviceDetectorService,
    private jobService: JobService,
    @Inject(MAT_DIALOG_DATA) public data: WorkOrderData) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    this.arrivalData = { customerId: this.data.customer.customer_ID, projectName: this.data.projectName,  arrivalInterval: null,  notificationComment: '', notificationType: 3  }
  }

  ngAfterViewInit() {
    this.notifyAllowed = this.checkContactsAvailable()
  }

  sendArrivalNotification(form: NgForm) {
    if (!form.valid || (this.arrivalData.arrivalInterval === null || this.arrivalData.arrivalInterval === undefined)) {
      return;
    }

   // this.arrivalData.arrivalWindow = this.selectedArrival;
    this.jobService.sendArrivalNotices(this.arrivalData)
      .subscribe({
        next: (data) => {
          this.dialogRef.close(this.data);
        },
        error: (error: string) => this.onError(error)
      });
  }

  checkContactsAvailable(): boolean {
    this.hasSMSContact = this.checkSMSContactAvailable();
    this.hasEmailContact = this.checkEmailContactAvailable();
    return this.hasSMSContact || this.hasEmailContact;
  }

  checkSMSContactAvailable(): boolean {
    if (this.data.customer.contacts.filter(c => c.contact_ReceivesNotifications && c.contact_OptedIn &&
      (c.contact_NotificationDeliveryTypeDesc === MessageNnotificationTypes_Enum.Both ||
        c.contact_NotificationDeliveryTypeDesc === MessageNnotificationTypes_Enum.Text) &&
      (c.contact_Mobile !== null && c.contact_Mobile !== '' && c.contact_Mobile !== undefined)).length > 0) { return true; }
    else { return false; } }

  checkEmailContactAvailable(): boolean {
    if (this.data.customer.contacts.filter(c => c.contact_ReceivesNotifications  &&
      (c.contact_NotificationDeliveryTypeDesc === MessageNnotificationTypes_Enum.Both ||
        c.contact_NotificationDeliveryTypeDesc === MessageNnotificationTypes_Enum.Email) &&
      (c.contact_Email !== null && c.contact_Email !== '' && c.contact_Email !== undefined)).length > 0) { return true; }
    else { return false; }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}
